// Components
import GeneralParameters from "pages/SizingTool/GeneralParameters";
import ListMeters from "pages/SizingTool/Meters/List";
import Results from "pages/SizingTool/Results";

// Redux
import { useDispatch, useSelector } from "react-redux";
import { selectCurrentCommunity } from "state/communities/communitiesSlice";
import { useGetTaskStatusByIdQuery } from "state/tasks/tasksApiSlice";
import { selectActiveTasksByType } from "state/tasks/tasksSlice";

// Utils
import useTaskStatusEffect from "utils/hooks/useTaskStatusEffect";
import { useGetGeneralParametersByCommunityIdQuery } from "state/generalParameters/generalParametersApiSlice";

const TASK_TYPE = "METER_PARAMETERS";

function SizingTool() {
  const dispatch = useDispatch();
  const community = useSelector(selectCurrentCommunity);
  const communityId = community?.id;

  // Fetch General Parameters
  const {
    data: generalParametersData,
    isLoading: isLoadingGeneral,
    isError,
  } = useGetGeneralParametersByCommunityIdQuery({ communityId }, { skip: !communityId });

  const transformedData = !isError ? generalParametersData : null;

  // Meter parameters task polling
  const activeMeterParameterTasks = useSelector(selectActiveTasksByType(TASK_TYPE));
  const {
    data: meterTaskStatus,
    isFetching: isLoadingMeterTask,
    isSuccess: isMeterTaskDone,
  } = useGetTaskStatusByIdQuery(
    { taskId: activeMeterParameterTasks[0]?.id, communityId },
    {
      pollingInterval: 3000,
      refetchOnFocus: true,
      refetchOnMountOrArgChange: true,
      skip: activeMeterParameterTasks.length === 0,
    }
  );

  useTaskStatusEffect({
    isSuccess: isMeterTaskDone,
    isFetching: isLoadingMeterTask,
    taskStatus: meterTaskStatus,
    activeLoadsTasks: activeMeterParameterTasks,
    dispatch,
    TASK_TYPE,
  });

  return (
    <div className="flex flex-col gap-rec">
      <GeneralParameters
        isLoading={isLoadingGeneral}
        data={transformedData}
        communityId={communityId}
      />
      <ListMeters />
      <Results communityId={communityId} />
    </div>
  );
}

export default SizingTool;
